import { FeatureFlag } from '@mews-distributor/common';
import { ProductsBreakdown as UIProductsBreakdown } from '@mews-distributor/ui';

import { useFeatureFlag } from '@mews/framework';
import {
    getEnhancedProductOrderPrices,
    getProductOrdersTotalPrice,
    getProductOrdersTotalPriceInSelectedCurrency,
} from '../../../../modules/productOrders/selectors';
import { WithReservationId } from '../../../../types/selectors/selectorPropTypes';
import { useAppSelector } from '../../../../utils/redux';

type ProductsBreakdownProps = WithReservationId;

export const ProductsBreakdown = ({ reservationId }: ProductsBreakdownProps) => {
    const dccFlowEnabled = useFeatureFlag(FeatureFlag.dccFlowEnabled);
    const items = useAppSelector((state) =>
        getEnhancedProductOrderPrices(state, { reservationId, shouldSelectedCurrencyBeUsed: dccFlowEnabled })
    );
    const productsTotalPrice = useAppSelector((state) =>
        dccFlowEnabled
            ? getProductOrdersTotalPriceInSelectedCurrency(state, reservationId)
            : getProductOrdersTotalPrice(state, { reservationId })
    );

    return <UIProductsBreakdown items={items} productsTotalPrice={productsTotalPrice} />;
};
